import MuiAppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { espacesUniquesNames, espacesUniquesKeys, url2 } from '../utils'
import { Button, Link } from '@material-ui/core'
import HomeIcon from '@mui/icons-material/Home'
import { useLocation } from 'react-router'
import Logo from '../assets/images/Logo.png'
import config from '../config'

const useStyles = makeStyles(
  (theme) => ({
    buttonLogout: {
      position: 'fixed',
      background: 'white',
      color: '#143A5F',
      fontSize: '11px',
      fontWeight: '500',
      padding: '.5em 4em',
      right: 9,
      top: 9,
      width: '5em',
      zIndex: 9999,
      '&:hover': {
        background: '#143A5F !important',
        color: '#ffffff !important',
      },
    },
    toolbar: {
      padding: '10px 20px',
    },
    img: {
      position: 'absolute',
      maxWidth: '36vw',
      maxHeight: '58px', //Appbar height
      [theme.breakpoints.down('sm')]: {
        position: 'static',
      },
    },
    title: {
      color: 'white',
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        marginRight: '2.5em',
      },
    },
  }),
  { name: 'RaAppBar' }
)

//elevation={0}
//https://stackoverflow.com/questions/34550593/how-to-disable-box-shadows-globally-for-all-material-ui-react-components
const ExtranetAppBar = (props) => {
  const location = useLocation()
  const { classes: classesOverride, className, ...rest } = props
  const classes = useStyles(props)
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'))

  let homePath = null
  let title = ''

  const isExtranetAg =
    location.pathname.indexOf(espacesUniquesKeys['ag']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ag2']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ag3']) !== -1
  const inProcessAg =
    isExtranetAg &&
    location.pathname
      .replace(espacesUniquesKeys['ag'], '')
      .replace(espacesUniquesKeys['ag2'], '')
      .replace(espacesUniquesKeys['ag3'], '').length > 0
  if (inProcessAg && location.pathname.indexOf('/convocation/') == -1) {
    const code = location.pathname.replace(espacesUniquesKeys['ag'] + '/', '')
    homePath = '/AG?code=' + code
  }
  if (location.pathname.indexOf(espacesUniquesKeys['pvag']) !== -1) {
    title = espacesUniquesNames['pvag']
  }
  if (location.pathname.indexOf(espacesUniquesKeys['copro']) !== -1) {
    title = espacesUniquesNames['copro']
    homePath = espacesUniquesKeys['coproprietaires']
  }
  if (location.pathname.indexOf(espacesUniquesKeys['coproprietaires']) !== -1) {
    title = espacesUniquesNames['coproprietaires']
  }
  if (location.pathname.indexOf(espacesUniquesKeys['coprofiche']) !== -1) {
    title = espacesUniquesNames['coprofiche']
    homePath = espacesUniquesKeys['coproprietaires']
  }
  if (location.pathname.indexOf(espacesUniquesKeys['coprotickets']) !== -1) {
    title = espacesUniquesNames['coprotickets']
    homePath = espacesUniquesKeys['coproprietaires']
  }
  const LogOut = (props) => {
    const classes = useStyles()
    const logout = () => {
      window.localStorage.removeItem('cpm_token')
      var logout_window = window.open(
        config.COPROMATIC_CONNECT + '/logout',
        '_blank'
      )
      setTimeout(function () {
        window.location.assign(window.location.origin + '/ext_coproprietaires')
        logout_window.close()
      }, 2000)
    }

    return (
      <Button
        variant="contained"
        color="primary"
        onClick={logout}
        className={classes.buttonLogout}
      >
        déconnexion
      </Button>
    )
  }
  return (
    <MuiAppBar
      position="static"
      className={className}
      color="white"
      elevation={0}
      id="no-printing-header"
      {...rest}
    >
      <Toolbar
        variant={isXSmall ? 'regular' : 'dense'}
        className={classes.toolbar}
      >
        <img src={Logo} className={classes.img} />
        <Typography
          variant="h5"
          color="primary"
          className={classes.title}
          align="center"
        >
          &nbsp; {title}
        </Typography>
        {homePath && (
          <Typography>
            <Link href={window.location.origin + homePath} color="inherit">
              <HomeIcon fontSize="large" sx={{ color: 'white' }} />
            </Link>
          </Typography>
        )}
      </Toolbar>
      {location.pathname.indexOf(espacesUniquesKeys['coproprietaires']) !==
        -1 && <LogOut />}
    </MuiAppBar>
  )
}

export default ExtranetAppBar
